import React from 'react'

export const CRM_LineaCreditoScreen = () => {
  return (
    <div>CRM_LineaCreditoScreen</div>
  )
}
